import { Tag } from '@omnipresentgroup/design-system';
import type { CombinedEmployee } from '@omnipresentgroup/types';

import { EMPLOYEE_STATUS_CONFIG } from './constants';

type EmployeeStatusProps = {
  status: CombinedEmployee['onboardingStatus'];
};

export const EmployeeStatus = ({ status }: EmployeeStatusProps) => {
  if (!status || !EMPLOYEE_STATUS_CONFIG[status]) {
    return null;
  }

  const { label, intent } = EMPLOYEE_STATUS_CONFIG[status];

  return (
    <Tag id={status} intent={intent}>
      {label}
    </Tag>
  );
};
